import WorkIcon from "@mui/icons-material/Work";

import CollapsibleListItem from "src/components/List/CollapsibleList";
import { useCourseRelationsContext } from "src/context/CourseRelationsContext";

import AircraftTreeItem from "./AircraftTreeItem";
import CoursesList from "./CoursesList";
import OperationTreeItem from "./OperationTreeItem";
import { highlightText } from "./utils";
import type { PositionTreeItemProps } from "./types";

const PositionTreeItem = ({ nodeId, position, expandedNodeIds, searchTerm }: PositionTreeItemProps) => {
  const actions = useCourseRelationsContext();
  const key = `${nodeId}/p${position.id}`;
  const { courses, customCourses, groups, operations, aircraft } = position;
  const hasItems = Boolean(courses?.length || customCourses?.length || groups?.length || operations?.length || aircraft?.length);
  const isExpanded = expandedNodeIds?.has(key) ?? false;

  return (
    <CollapsibleListItem
      nodeId={key}
      icon={<WorkIcon />}
      isExpandable={hasItems}
      title={highlightText(position.name, searchTerm)}
      onClick={() => actions.nodeClicked(key)}
      forceExpanded={isExpanded}
    >
      <CoursesList
        nodeId={key}
        courses={courses}
        customCourses={customCourses}
        groups={groups}
        searchTerm={searchTerm}
      />

      {aircraft?.map((aircraft) => (
        <AircraftTreeItem
          key={`${key}/a${aircraft.id}`}
          aircraft={aircraft}
          nodeId={key}
          expandedNodeIds={expandedNodeIds}
          searchTerm={searchTerm}
        />
      ))}

      {operations?.map((operation) => (
        <OperationTreeItem
          key={`${key}/o${operation.id}`}
          operation={operation}
          nodeId={key}
          expandedNodeIds={expandedNodeIds}
          searchTerm={searchTerm}
        />
      ))}
    </CollapsibleListItem>
  );
};

export default PositionTreeItem;
